export const cltLayerOrientationLabels: Record<CLTLayerOrientation, string> = {
  Parallel: 'Parallel',
  Orthogonal: 'Orthogonal',
}
